import React, {useEffect} from "react";
import { DialogTitle, IconButton, DialogContent, Typography, Link as MuiLink} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


const PrivacyPolicy = ({handleClose}) => {

// const  handleSubmit=()=>{
//   agreementCheck({target: {checked: true}})
//     handleClose()
//   }

  useEffect(() => {
    window.open("https://www.makingview.com/privacy-policy", "_blank", "noopener,noreferrer");
    handleClose(); // optional: close dialog if this component is inside one
  }, []);

  return null;
};
export default PrivacyPolicy;
